import React from 'react'
import Headers from '../headers/Headers'

const AllPools = () => {
  return (
    <>
    <Headers/>
      <div>
        <h1>All Pools.</h1>
      </div>
    </>
  )
}

export default AllPools
